import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Youtube } from "lucide-react";
import Reveal from "./Reveal";

const VIDEOS = [
  { id: "AN1V23NXIL0", title: "Teaser live", tag: "Teaser" },
  { id: "At1L-4Q1Elo", title: "Georgy Porgy", tag: "Toto" },
  { id: "lg8EyaPuxxQ", title: "Heavy Cross", tag: "Gossip" },
  { id: "jEciJf0PTks", title: "J'irai où tu iras", tag: "Céline Dion & J-J Goldman" },
  { id: "DIpidh7Wspw", title: "Zombie", tag: "The Cranberries" },
  { id: "tOC-icR1ys4", title: "Video Killed the Radio Star", tag: "The Buggles" },
];

const Videos = () => {
  const [active, setActive] = useState(VIDEOS[0]);

  return (
    <section id="videos" data-testid="youtube-showcase-section" className="relative py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.25em] font-jbmono font-semibold text-amber-400 mb-4">
            En écoute
          </p>
          <h2 className="font-display text-2xl sm:text-4xl font-bold tracking-tight uppercase mb-3">
            Le son <span className="text-amber-500">Forty One</span> en vidéo
          </h2>
          <p className="text-zinc-400 max-w-2xl text-base mb-12">
            Des extraits filmés en conditions réelles. Ce que vous entendez ici
            est exactement ce que votre public entendra.
          </p>
        </Reveal>

        <div className="grid lg:grid-cols-3 gap-6 items-start">
          <Reveal className="lg:col-span-2">
            <AnimatePresence mode="wait">
              <motion.div
                key={active.id}
                initial={{ opacity: 0, scale: 0.98 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.98 }}
                transition={{ duration: 0.4 }}
                className="relative rounded-2xl overflow-hidden border border-amber-500/20 bg-[#161622] glow-amber"
              >
                <div className="aspect-video">
                  <iframe
                    data-testid="youtube-player"
                    className="w-full h-full"
                    src={`https://www.youtube.com/embed/${active.id}?rel=0`}
                    title={active.title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
                <div className="flex items-center justify-between px-5 py-4">
                  <div>
                    <p className="font-display font-bold uppercase tracking-wide">{active.title}</p>
                    <p className="text-xs font-jbmono text-zinc-500 uppercase tracking-widest mt-0.5">{active.tag}</p>
                  </div>
                  <a
                    data-testid="youtube-channel-link"
                    href="https://www.youtube.com/@41fortyone"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 text-xs font-jbmono uppercase tracking-wider text-zinc-400 hover:text-red-500 transition-colors duration-300"
                  >
                    <Youtube size={15} />
                    @41fortyone
                  </a>
                </div>
              </motion.div>
            </AnimatePresence>
          </Reveal>

          <div className="flex lg:flex-col gap-3 overflow-x-auto lg:overflow-visible pb-2 lg:pb-0">
            {VIDEOS.map((v, i) => (
              <Reveal key={v.id} delay={i * 0.06} y={20}>
                <button
                  data-testid={`video-thumb-${v.id}`}
                  onClick={() => setActive(v)}
                  className={`group flex items-center gap-3 w-64 lg:w-full text-left rounded-xl border p-2.5 transition-colors duration-300 ${
                    active.id === v.id
                      ? "border-amber-500/60 bg-[#1E1E2E]"
                      : "border-zinc-800 bg-[#161622] hover:border-amber-500/30"
                  }`}
                >
                  <div className="relative w-24 shrink-0 rounded-lg overflow-hidden">
                    <img
                      src={`https://i.ytimg.com/vi/${v.id}/hqdefault.jpg`}
                      alt={v.title}
                      className="w-full aspect-video object-cover"
                      loading="lazy"
                    />
                    {active.id === v.id && (
                      <div className="absolute inset-0 bg-amber-500/20 flex items-center justify-center">
                        <span className="w-2 h-2 rounded-full bg-amber-500 animate-pulse" />
                      </div>
                    )}
                  </div>
                  <div className="min-w-0">
                    <p className={`text-sm font-semibold truncate transition-colors duration-300 ${active.id === v.id ? "text-amber-400" : "text-zinc-200 group-hover:text-amber-400"}`}>
                      {v.title}
                    </p>
                    <p className="text-[11px] font-jbmono uppercase tracking-widest text-zinc-500 truncate mt-0.5">{v.tag}</p>
                  </div>
                </button>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Videos;
